
import { Component, OnInit, OnDestroy, ViewContainerRef } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { from } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import * as MusicMetadata from 'music-metadata-browser';
import { DialogService } from '../../_services/dialog.service';
import * as moment from 'moment';

@Component({
  templateUrl: './track-metadata-modal.component.html',
  styleUrls: ['./track-metadata-modal.component.css']
})
export class TrackMetadataModalComponent implements OnInit {
  public loading = false;

  public track;
  public metadata;

  public form: FormGroup;

  constructor(
    private bsModalRef: BsModalRef,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private dialogService: DialogService,
    private viewRef: ViewContainerRef
  ) { }

  ngOnInit() {
    this.loading = true;
    this.spinner.show();
    from(MusicMetadata.fetchFromUrl(this.track.trackUrl))
      .subscribe(res => {
        this.loading = false;
        this.spinner.hide();
        this.initForm(res);
      }, error => {
        this.loading = false;
        this.spinner.hide();
        this.dialogService.alert('Uh oh!', 'Something went wrong when trying to fetch the metadata for that song.', this.viewRef);
      })
  }

  initForm(metadata: MusicMetadata.IAudioMetadata){
    const duration = moment.duration(metadata.format.duration, 'seconds');
    const minutes = duration.minutes() < 10 ? '0' + duration.minutes().toString() : duration.minutes().toString();
    const seconds = duration.seconds() < 10 ? '0' + duration.seconds().toString() : duration.seconds().toString();
    const durationString = minutes + ':' + seconds;

    this.form = this.fb.group({
      container: [{value: metadata?.format?.container ?? 'Not found', disabled: true}],
      codec: [{value: metadata?.format?.codec ?? 'Not found', disabled: true}],
      duration: [{value: durationString ?? 'Not found', disabled: true}],
      bitDepth: [{value: metadata?.format?.bitsPerSample ?? 'Not found', disabled: true}],
      sampleRate: [{value: metadata?.format?.sampleRate ?? 'Not found', disabled: true}],
      lossless: [{value: metadata?.format?.lossless ?? 'Not found', disabled: true}],
      numberOfChannels: [{value: metadata?.format?.numberOfChannels ?? 'Not found', disabled: true}],
      trackGain: [{value: metadata?.format?.trackGain ?? 'Not found', disabled: true}],

      name: [{value: metadata?.common?.title ?? 'Not found', disabled: true}],
      artist: [{value: metadata?.common?.artist ?? 'Not found', disabled: true}],
      album: [{value: metadata?.common?.album ?? 'Not found', disabled: true}],
    })
  }

  close() {
    this.bsModalRef.hide();
  }
}
